import { defineMessages } from 'react-intl-next';

export default defineMessages({
	spellingAndGrammarButtonLabel: {
		id: 'fabric.editor.ai.spellingAndGrammarButton.tooltip',
		defaultMessage: 'Spelling and grammar check (Beta)',
		description: 'The tooltip text for the spelling and grammar button in the Editor toolbar',
	},
});
